export enum CRUD {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete'
}
